const mapMarkers = [
  {
    lat: 18.424357461589384,
    lng: -67.15513058878625,
    name: "La Grifería",
    type: "pin",
  }
];

export default mapMarkers;